import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import DestinationSection from './components/DestinationSection';
import FeaturedArticles from './components/FeaturedArticles';
import ExperienceSection from './components/ExperienceSection';
import FAQSection from './components/FAQSection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '亚洲天堂',
  alternateName: 'Asia Paradise',
  url: 'https://asiaparadise.com/',
  description: '亚洲天堂，带您领略东南亚、东亚及南亚最令人心动的绝美目的地。从碧海白沙到千年古迹，从热带雨林到都市繁华，亚洲天堂汇聚亚洲顶级旅游资源，为您打造一站式梦幻旅行体验。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://asiaparadise.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '亚洲天堂',
  alternateName: 'Asia Paradise',
  url: 'https://asiaparadise.com/',
  description: '亚洲天堂——探索东方最美旅游胜地',
  email: 'contact@asiaparadise.com',
  telephone: '+86-400-888-9999',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '上海',
    addressRegion: '上海',
    addressCountry: 'CN',
  },
  sameAs: [],
};

const webpageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '亚洲天堂——探索东方最美旅游胜地',
  description: '亚洲天堂，带您领略东南亚、东亚及南亚最令人心动的绝美目的地。从碧海白沙到千年古迹，从热带雨林到都市繁华，亚洲天堂汇聚亚洲顶级旅游资源，为您打造一站式梦幻旅行体验。',
  url: 'https://asiaparadise.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '亚洲天堂',
    url: 'https://asiaparadise.com/',
  },
  inLanguage: 'zh-CN',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>

      <Navbar />

      <main>
        <HeroBanner />
        <DestinationSection />
        <ExperienceSection />
        <FeaturedArticles />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}